var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.articleDocument)?_c('div',{staticClass:"article"},[_c('div',{attrs:{"id":"article"}},[_c('article-header',{class:{
        'visually-hidden': _vm.articleDocument.with_image_header === false,
      },attrs:{"article":_vm.articleDocument}}),_vm._v(" "),_c('article',[_c('blocks',{attrs:{"blocks":_vm.articleDocument.blocks}})],1)],1),_vm._v(" "),(_vm.hasOverrideColors)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getOverrideColorsStyle())}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }